import { Box, Grid } from "@mui/material";
import React, { useContext, useState } from "react";
import Label from "../../../components/label";
import TextInput from "../../../components/textInput";
import GlobalButton from "../../../components/button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../lib/Context";
import { loginValidation } from "../../../utils/Validation";
import { encryptPassword, handleOpenSnackBar } from "../../../utils/helper";
import { loginUser } from "../../../services/AgentApi";
import { setAccessToken } from "../../../services/tokenStore";
import AppLoader from "./../../../components/loader/index";

const LoginForm = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [inputValue, setInputValue] = useState({
    name: "",
    email: "",
  });
  const [inputError, setInputError] = useState({
    email: false,
    isValidEmail: false,
    password: false,
  });
  const { userData, setUserData } = useContext(AppContext);

  const handleChangeValue = (event) => {
    const { name, value } = event.target;

    setInputError((preError) => ({
      ...preError,
      [name]: false,
      isValidEmail: name === "email" ? false : inputError.isValidEmail,
    }));
    setInputValue((preValue) => ({ ...preValue, [name]: value }));
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async () => {
    try {
      const validate = loginValidation(inputValue, setInputError);
      if (validate) {
        return;
      }

      let payload = {
        email: inputValue.email,
        password: encryptPassword(inputValue.password),
      };

      setIsLoading(true);
      const response = await loginUser(payload);
      if (response?.data.status === "success") {
        const user = response.data.data.user;
        const accessToken = response.data.data.token;

        setAccessToken(accessToken);
        localStorage.setItem("user_data", JSON.stringify(user));
        setUserData(user);
        navigate("/");
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box component={"form"} mt={5}>
      <AppLoader isVisible={isLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Label title={"Email"} htmlFor={"login-email"} />
          <TextInput
            id={"login-email"}
            required
            type={"email"}
            placeholder={"Enter your email address"}
            error={inputError.email || inputError.isValidEmail}
            helperText={
              inputError.email
                ? "Email address is required"
                : inputError.isValidEmail
                ? "Invalid email address"
                : null
            }
            name={"email"}
            value={inputValue.email}
            onChange={handleChangeValue}
          />
        </Grid>
        <Grid item xs={12}>
          <Label title={"Password"} />
          <TextInput
            id={"password"}
            type={showPassword ? "text" : "password"}
            required
            placeholder={"Enter your password"}
            error={inputError.password}
            helperText={inputError.password ? "Password is required" : null}
            name={"password"}
            value={inputValue.password}
            onChange={handleChangeValue}
            InputEndIcon={
              showPassword ? (
                <VisibilityIcon onClick={handleTogglePassword} />
              ) : (
                <VisibilityOffIcon onClick={handleTogglePassword} />
              )
            }
          />
        </Grid>
      </Grid>
      <GlobalButton
        variant={"custom_gradient"}
        title={"Login"}
        handleClickBtn={handleLogin}
        style={{
          marginTop: 5,
          height: 50,
          fontWeight: 600,
          fontSize: "1.125rem",
        }}
      />
    </Box>
  );
};

export default LoginForm;
